import type { FilterSection } from "@/types/filterTypes";

export const useProgrammesFilterSections = (): FilterSection[] => {

  return [
    {
      key: "landingPageAfsaProgramme",
      label: "Landing Page",
      type: "boolean",
    },
    {
      key: "allowComments",
      label: "Is Comment Allowed",
      type: "boolean",
    },
    {
      key: "createdStartDate",
      label: "Created At Start Date",
      type: "date",
      placeholder: "From"
    },
    {
      key: "createdEndDate",
      label: "Created At End Date",
      type: "date",
      placeholder: "To"
    },
    {
      key: "publishedStartDate",
      label: "Published At Start Date",
      type: "date",
      placeholder: "From"
    },
    {
      key: "publishedEndDate",
      label: "Published At End Date",
      type: "date",
      placeholder: "To"
    }
  ];
};
